<template>
	<h3 v-if="heading" class="text-base font-medium text-gray-900">
		{{ heading }}
	</h3>

	<AccountFormField
		:id="`${idPrefix}street`"
		:label="$t('street_address')"
		label-class="capitalize"
		:field="validation.Line1"
	>
		<template #default="{ attrs }">
			<input
				v-model="line1"
				v-bind="attrs"
				name="street"
				type="text"
				autocomplete="street"
			/>
		</template>
	</AccountFormField>

	<div class="flex gap-4">
		<AccountFormField
			:id="`${idPrefix}zipcode`"
			class="w-1/3"
			:label="$t('zip_code')"
			:field="validation.Zip"
		>
			<template #default="{ attrs }">
				<input
					v-model="zip"
					v-bind="attrs"
					name="Zip"
					type="text"
					autocomplete="zipcode"
				/>
			</template>
		</AccountFormField>

		<AccountFormField
			:id="`${idPrefix}city`"
			class="w-2/3"
			:label="$t('city')"
			:field="validation.City"
		>
			<template #default="{ attrs }">
				<input
					v-model="city"
					v-bind="attrs"
					name="city"
					type="text"
					autocomplete="city"
				/>
			</template>
		</AccountFormField>
	</div>

	<AccountFormField
		:id="`${idPrefix}country`"
		:label="$t('country')"
		:field="validation.CountryId"
	>
		<template #default="{ attrs }">
			<SwSelect
				:id="attrs.id"
				v-model="countryId"
				:compact="false"
				name="CountryId"
				autocomplete="country-name"
				:options="countryOptions"
				:placeholder="$t('choose_country_placeholder')"
				:class="{ 'border-red-600': validation.CountryId.$error }"
			/>
		</template>
	</AccountFormField>
</template>

<script setup lang="ts">
import type { ValidationField } from "~/types/account";
import SwSelect from "../Shared/SwSelect.vue";

/** Prefixed so a second address block on the same form keeps unique ids. */
const { idPrefix = "", heading = "" } = defineProps<{
	validation: {
		Line1: ValidationField;
		Zip: ValidationField;
		City: ValidationField;
		CountryId: ValidationField;
	};
	countryOptions: { label: string; value: number }[];
	idPrefix?: string;
	heading?: string;
}>();

const line1 = defineModel<string>("line1", { required: true });
const zip = defineModel<string>("zip", { required: true });
const city = defineModel<string>("city", { required: true });
const countryId = defineModel<number | undefined>("countryId", {
	required: true
});
</script>
